export const routes = {
  home: '/',
  sites: '/sites',
  addSite: '/sites/create',
};
